var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83268 2.33329V0.666626H13.166V2.33329H17.3327V3.99996H15.666V16.5C15.666 16.721 15.5782 16.9329 15.4219 17.0892C15.2657 17.2455 15.0537 17.3333 14.8327 17.3333H3.16602C2.945 17.3333 2.73304 17.2455 2.57676 17.0892C2.42048 16.9329 2.33268 16.721 2.33268 16.5V3.99996H0.666016V2.33329H4.83268ZM3.99935 3.99996V15.6666H13.9993V3.99996H3.99935ZM6.49935 6.49996H8.16602V13.1666H6.49935V6.49996ZM9.83268 6.49996H11.4993V13.1666H9.83268V6.49996Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNew);
export default __webpack_public_path__ + "static/media/delete_new.2b514e27373f60dc4d8eefeb6c157693.svg";
export { ForwardRef as ReactComponent };